import React from "react";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { BiCoinStack } from "react-icons/bi";
import { IoLockClosedOutline } from "react-icons/io5";
import { BiLike } from "react-icons/bi";
import img1 from "../../../../assets/img/Services/IAMSecuritySolutions/centalized.png";
import { FaCompass, FaDesktop, FaPaintBrush, FaUserAlt } from "react-icons/fa";
import { AiOutlineSafety } from "react-icons/ai";

export default function MainSection3() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="flex flex-col mb-6 pb-12 justify-center lg:justify-center lg:flex-row md:mb-8">
        <h2 className="max-w-lg font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
          <span className="inline-block mb-1 sm:mb-4">Our Offerings</span>
          <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
        </h2>
      </div>
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Centralized Identity Management"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Centralized Identity Management
            </h1>
            <p className="text-lg text-gray-600">
              Manage all user identities across on-premises, cloud, and hybrid environments from a single, unified platform.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaUserAlt className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Consolidated Identity Systems</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Consolidate multiple identity systems into one streamlined solution.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaDesktop className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Seamless Integration</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Enable seamless integration with HR systems, CRMs, and other critical applications.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineSafety className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Automated Provisioning</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Monitor identity lifecycles with automated provisioning and de-provisioning.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
